import React, { useContext, useMemo } from 'react';
import RouteringPageEdit from './routering/routering.page.edit';
import AuthenticationContext from './security/authentication.context';
import { ActionSpinner } from './components/actionspinner/action-spinner';
import IncompleteProfile from './security/incomplete-profile';
import NotAuthenticated from './security/not-authenticated';
import { useRoleHook } from './security/use-role-hook';
import RouteringPageView from './routering/routering.page.view';

const HomePage: React.FC<any> = () => {
  const { busyAuthenticating, authenticated, authorised } = useContext(AuthenticationContext);
  const { isBeheerder } = useRoleHook();

  return useMemo(() => {
    if (busyAuthenticating) {
      return <ActionSpinner />;
    } else if (authenticated) {
      if (!authorised) {
        return <IncompleteProfile />;
      }
      return isBeheerder ? <RouteringPageView /> : <RouteringPageEdit />;
    }
    return <NotAuthenticated />;
  }, [busyAuthenticating, authenticated, authorised, isBeheerder]);
};

export default HomePage;
